// Version : 0.0.1
// Author : SABARI
// LastEdit : SABARI
// Last ADD : Added the comments
// MODIFIED DATE : 27-09-2025

import { makeApiCall } from '../../_common/api.utils';
import { API_URL, FIN_API_URL } from '../../const';

/** ***************** GET ALL CLOSE LOAN ADVANCE START *********************** */
export const fetchAllLoanAdvanceCollectedMembersList = (listData: any) => {
	const data = {
		GetAllLoanAdvanceCollectedMemberToken: listData,
	};
	const url = `${API_URL}getAllLoanAdvanceCollectedMembersList`;
	return makeApiCall(url, data);
};
/** ***************** GET ALL CLOSE LOAN ADVANCE END *********************** */

/** ***************** FETCH PARTICULAR ACCOUNT NAME INFO START *********************** */
export const fetchParticularAccountName = (requestData: any) => {
	const data = {
		GetParticularAccountNameInfoToken: requestData,
	};
	const url = `${FIN_API_URL}fetchParticularAccountNameInfo`;
	return makeApiCall(url, data);
};
/** ***************** FETCH PARTICULAR ACCOUNT NAME INFO END *********************** */

/** ***************** FETCH ACCOUNTS BASEDON TYPE START *********************** */
export const fetchAccountsBasedonType = (requestData: any) => {
	const data = {
		getAccountsBasedonTypeToken: requestData,
	};
	const url = `${API_URL}getAccountsBasedonType`;
	return makeApiCall(url, data);
};
/** ***************** FETCH ACCOUNTS BASEDON TYPE END *********************** */

/** ***************** UPDATE CLOSE LOAN ADVANCE WITH REPAYMENT START *********************** */
export const updateCloseLoanAdvanceWithRepayment = (requestData: any) => {
	const data = {
		updateCloseLoanAdvanceToken: requestData,
	};
	const url = `${API_URL}updateCloseLoanAdvanceWithRepayment`;
	return makeApiCall(url, data);
};
/** ***************** UPDATE CLOSE LOAN ADVANCE WITH REPAYMENT END *********************** */

/** ***************** REVERT CLOSE LOAN ADVANCE WITH REPAYMENT START *********************** */
export const revertCloseLoanAdvanceWithRepayment = (requestData: any) => {
	const data = {
		RevertCloseLoanAdvanceToken: requestData,
	};
	const url = `${API_URL}revertCloseLoanAdvanceWithRepayment`;
	return makeApiCall(url, data);
};
/** ***************** REVERT CLOSE LOAN ADVANCE WITH REPAYMENT END *********************** */
